import moment from 'moment-timezone';
import { isEmpty, get, isNull, isNil, intersection, uniq } from 'lodash';
import {
  PAGES,
  MANAGER_ROUTES,
  LAWYER_ROUTES,
  COURT_MANAGER_ROUTES,
  EXPERT_ROUTES,
  PREOPEN_MANAGER_ROUTES,
  ISCONSULTATION_MANAGER_ROUTES,
  TRANSACTION_MANAGER_ROUTES,
  PAGES_INDEX_COURT_MANAGER,
} from 'routes';
import {
  DOCTOR_ROLE,
  ACCOUNTING_ROLE,
  MECHANIC_ROLE,
  PATH_LAWYER,
  PATH_MANAGER,
  NOTIFICATION_CLAIM_CONVERTION,
  EXPERT_REJECTION_TITLE_NOTIFICATION,
  DELAY_MISSION_TITLE_MOTIFICATION,
  ASSIGNEMENT_INBOXE_TITLE_NOTIFICATION,
  SETTLEMENT_PHASE,
} from 'containers/AppContainer/constants';
import {
  PAGES_INDEX,
  PAGES_INDEX_MANAGER,
  PAGES_INDEX_PREOPEN_MANAGER,
} from 'routes';
import { translate } from 'containers/services/translate';
import { AppContainerProps } from 'containers/AppContainer';
import {
  ClaimByStatus,
  INotification,
  SagisConfig,
} from 'containers/AppContainer/typings';
import {
  CLAIM,
  MISSION_POSTPONE_TYPE,
  PROCEDURE_STATUSES,
} from 'containers/data-structure';
import currentUserStorage from 'containers/services/security/current-user-storage';
import accessTokenStorage from 'containers/services/security/access-token-storage';
import userPrivileges, {
  PRIVILEGES,
  userHasPrivilege,
} from 'containers/services/security/user-privileges';
import { SagisLawyerAssignedClaims } from 'containers/ManagerOpenedClaimsPage/typings';
import {
  OPENING_INBOXES,
  CICA_MIXTE_INBOXES,
  OPENING_CORPOR_INBOXES,
  LAWYER_INBOXES_TITLES,
} from 'containers/AppContainer/AppBar/constants';
import messages from 'containers/AppContainer/messages';
import { STATUS_REJECTED } from 'containers/LawyerFeeNote/constants';
import { TRANSACTION_STEPS } from 'containers/TransactionManagerTimeLine/constants';
import { LAWYER_ROLE } from 'containers/AppContainer/constants';
import currentIntervenantStorage, {
  CurrentLawyer,
  CURRENT_INTERVENANT_KEY,
} from 'containers/services/security/current-intervenant-storage';
import { PROCEDURE_TYPES } from 'containers/LawyerLegalProceedingsPage/constants';
import OverLayStorage from 'containers/services/security/overlay-storage';

export const isManager = (props: { location: { pathname: string } }) => {
  if (
    props.location.pathname.startsWith(PAGES.MANAGER_HOME) ||
    props.location.pathname.startsWith(PAGES.COURT_MANAGER_HOME) ||
    props.location.pathname.startsWith(PAGES.MONITORING_MANAGER_HOME) ||
    props.location.pathname.startsWith(PAGES.PREOPEN_MANAGER_HOME) ||
    props.location.pathname.startsWith(PAGES.CONSULTATION_MANAGER_HOME) ||
    props.location.pathname.startsWith(PAGES.TRANSACTION_MANAGER_HOME)
  ) {
    return true;
  }

  return false;
};

export const isExpert = (props: { location: { pathname: string } }) => {
  const currentUserString = window.localStorage.getItem(
    CURRENT_INTERVENANT_KEY,
  );
  const currentUser = JSON.parse(currentUserString as string);
  return (
    currentUser?.roles.includes(DOCTOR_ROLE) ||
    currentUser?.roles.includes(ACCOUNTING_ROLE) ||
    currentUser?.roles.includes(MECHANIC_ROLE)
  );
};

export const isExpertAccounting = (props: {
  location: { pathname: string };
}) => {
  const currentUserString = window.localStorage.getItem(
    CURRENT_INTERVENANT_KEY,
  );
  const currentUser = JSON.parse(currentUserString as string);
  return currentUser?.roles.includes(ACCOUNTING_ROLE);
};

export const isExpertMechanic = (props: { location: { pathname: string } }) => {
  const currentUserString = window.localStorage.getItem(
    CURRENT_INTERVENANT_KEY,
  );
  const currentUser = JSON.parse(currentUserString as string);
  return currentUser?.roles.includes(MECHANIC_ROLE);
};
export const isCourtManager = () => {
  if (
    userHasPrivilege(PRIVILEGES.ISCOURTMANAGER) ||
    userHasPrivilege(PRIVILEGES.ISCOURTMONITORINGMANAGER)
  ) {
    return true;
  }

  return false;
};

export const isNotOpeningManager = () => {
  if (
    userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER) &&
    !userHasPrivilege(PRIVILEGES.ISMANAGER)
  ) {
    return true;
  }
  return false;
};
export const isOpeningManager = () => {
  if (
    (userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER) &&
      !userHasPrivilege(PRIVILEGES.ISMANAGER)) ||
    (userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER) &&
      userHasPrivilege(PRIVILEGES.ISMANAGER))
  ) {
    return true;
  }
  return false;
};
export const isMonitoringManager = () => {
  if (userHasPrivilege(PRIVILEGES.ISCOURTMONITORINGMANAGER)) {
    return true;
  }
  return false;
};
export const getRoutesByProfile = (props: AppContainerProps) => {
  if (utils.isManager(props)) {
    if (userPrivileges.userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER)) {
      return MANAGER_ROUTES;
    } else if (
      userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER) ||
      userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMONITORINGMANAGER)
    ) {
      return COURT_MANAGER_ROUTES;
    } else if (userPrivileges.userHasPrivilege(PRIVILEGES.ISPREOPENMANAGER)) {
      return PREOPEN_MANAGER_ROUTES;
    } else if (
      userPrivileges.userHasPrivilege(PRIVILEGES.ISCONSULTATIONMANAGER)
    ) {
      return ISCONSULTATION_MANAGER_ROUTES;
    } else if (
      userPrivileges.userHasPrivilege(PRIVILEGES.ISTRANSACTIONMANAGER)
    ) {
      return TRANSACTION_MANAGER_ROUTES;
    }
  } else if (utils.isExpert(props)) {
    return EXPERT_ROUTES;
  }
  return LAWYER_ROUTES;
};

export const formatClaim = (
  claims: ClaimByStatus[],
  cities: SagisConfig[],
  sagisLawyerAssignedClaims?: SagisLawyerAssignedClaims[],
) => {
  if (isEmpty(claims)) return [];
  return claims.map(claim => {
    const city = cities.find(
      (city: SagisConfig) => city.ItemKey === claim.lossLocation,
    );

    const sagisAssignedLawyer = (sagisLawyerAssignedClaims || []).find(
      lawyer => lawyer.claimNumber === claim.claimNumber,
    );

    return {
      ...claim,
      [CLAIM.LOSS_LOCATION_LABEL]: get(city, 'ItemDescription'),
      isSagisLawyerAssigned: get(sagisAssignedLawyer, 'haveAssignedLawyer'),
    };
  });
};

export const isTokenNotValid = (props: AppContainerProps) => {
  let tokenNotExpired = null;

  if (!isEmpty(accessTokenStorage.get())) {
    const expirationDate = moment(accessTokenStorage.get().loginDate)
      .add(accessTokenStorage.get().experitationPeriod, 's')
      .format();

    tokenNotExpired = moment().isBetween(
      accessTokenStorage.get().loginDate,
      expirationDate,
    );
  }

  return (
    utils.isManager(props) &&
    (isEmpty(currentUserStorage.get()) || !tokenNotExpired)
  );
};

export const utils = { isManager, isExpert };

export const resolveCount = (
  lawyerNotifications: INotification[],
  id: number,
) => lawyerNotifications.filter(el => el.binLawyerId === id).length;

export const isUserHasValidRole = (
  roles: string[],
  intervenants: SagisConfig[],
  sagisCode: string,
) => {
  if (!isEmpty(intervenants)) {
    const intervenantCodes = uniq(
      intervenants.map((el: SagisConfig) => String(el.ItemKey)),
    );
    const roleValues = roles.map((el: string) => el.toLowerCase());
    const intervenantTypes = intervenants.map((el: SagisConfig) =>
      el.ItemDescription.toLowerCase(),
    );
    const intervenantType = intersection(roleValues, intervenantTypes);
    if (
      !isEmpty(intervenantType) &&
      intervenantType.length === 1 &&
      intervenantCodes.includes(sagisCode)
    )
      return true;
    return false;
  }
  return false;
};

export const countNotifications = (
  props: any,
  managerNotifications: any,
  expertNotifications: any,
  lawyerNotifications: any,
  openingManagerNotificationsMixedClaim: any,
  isManagerOpeningManager: any,
  sagisCode: any,
  isMonitoringCourtManager: any,
  isManagerCourtMonitoringManager: any,
  isOpeningManager: any,
  OpeningTypeNotifications: any,
) => {
  if (isManager(props)) {
    if (isManagerOpeningManager) {
      return (
        props.countNotificationsManager +
        openingManagerNotificationsMixedClaim.filter(
          (el: any) =>
            el.status === PROCEDURE_STATUSES.PENDING &&
            isNil(el?.managerNotificationTypeId) &&
            !OpeningTypeNotifications.includes(el?.managerNotificationTypeId),
        ).length
      );
    } else if (isMonitoringCourtManager) {
      return props.countNotificationsManager;
    } else if (isManagerCourtMonitoringManager) {
      return props.countNotificationsManager;
    } else if (isOpeningManager) {
      return (
        props.countNotificationsManager +
        openingManagerNotificationsMixedClaim.filter(
          (el: any) =>
            el.status === PROCEDURE_STATUSES.PENDING &&
            isNil(el?.managerNotificationTypeId) &&
            !OpeningTypeNotifications.includes(el?.managerNotificationTypeId),
        ).length
      );
    } else {
      return props.countNotificationsManager;
    }
  } else if (isExpert(props)) {
    return expertNotifications.filter(
      (el: any) => el.readBy === null && el.expertCode === sagisCode,
    ).length;
  } else {
    return lawyerNotifications.filter(
      (el: any) => el.readBy === null && el.lawyerCode === sagisCode,
    ).length;
  }
};

export const countInboxesNotification = (managerNotifications: any) => {
  const userInboxesId =
    !isEmpty(userPrivileges.getUserInboxes()) &&
    userPrivileges.getUserInboxes()?.map((el: any) => el.managerInboxe.id);
  return !isEmpty(userInboxesId)
    ? managerNotifications?.filter(
        (el: any) =>
          el.treatedBy === null &&
          userInboxesId?.includes(el.managerNotificationType?.managerInboxesId),
      )?.length
    : 0;
};

export const extractOpeningNotificationType = (listing: any) => {
  const openingInboxeId = get(listing, 'managerInboxes', [])
    .filter(
      (el: any) =>
        el.title === OPENING_INBOXES ||
        el.title === CICA_MIXTE_INBOXES ||
        el.title === OPENING_CORPOR_INBOXES,
    )
    .map((it: any) => it.id);

  const notificationType = get(listing, 'managerNotificationType', [])
    .filter((el: any) => openingInboxeId.includes(el.managerInboxesId))
    .map((item: any) => item.id);
  return notificationType;
};

export const renderPath = (
  props: any,
  isManagerOpeningManager: boolean,
  currentClaimId: any,
  isClaimRejected: any,
  currentExpertNotification: any,
  currentManagerNotification: any,
  isPreOpeningManager: any,
  isInvoiceNotification: boolean,
  isTransactionManager: boolean,
  isProvisionalClaimNotification: boolean,
  provisionalClaimId: number | null,
) => {
  if (utils.isManager(props)) {
    if (
      !isEmpty(
        get(currentManagerNotification, 'notificationManagerMapping', []),
      ) &&
      !isEmpty(
        get(
          currentManagerNotification,
          'notificationManagerMapping',
          [],
        ).filter(
          (item: any) =>
            get(item, 'userPrivilegesId') ===
            get(currentUserStorage.get().privileges, 'id'),
        ),
      ) &&
      isNull(get(currentManagerNotification, 'claimId', null))
    ) {
      return `${PAGES.COURT_MANAGER_HOME}`;
    }
    if (
      !isEmpty(
        get(currentManagerNotification, 'notificationManagerMapping', []),
      ) &&
      !isEmpty(
        get(
          currentManagerNotification,
          'notificationManagerMapping',
          [],
        ).filter(
          (item: any) =>
            get(item, 'userPrivilegesId') ===
            get(currentUserStorage.get().privileges, 'id'),
        ),
      ) &&
      !isNull(currentClaimId) &&
      isPreOpeningManager
    ) {
      return `${PAGES.PREOPEN_MANAGER_RECAP_PAGE}/${currentClaimId}`;
    } else if (!isNull(get(currentManagerNotification, 'feeNoteId', null))) {
      return `${PAGES.MANAGER_FEE_NOTE}`;
    } else if (
      isNull(get(currentManagerNotification, 'claimId', null)) &&
      !isNull(get(currentManagerNotification, 'sagisNotificationId', null))
    ) {
      return userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER)
        ? `${PAGES.MANAGER_HOME}`
        : `${PAGES.COURT_MANAGER_HOME}`;
    } else if (
      isManagerOpeningManager ||
      userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER)
    ) {
      if (
        !isEmpty(
          get(currentManagerNotification, 'notificationManagerMapping', []),
        ) &&
        !isEmpty(
          get(
            currentManagerNotification,
            'notificationManagerMapping',
            [],
          ).filter(
            (item: any) =>
              get(item, 'userPrivilegesId') ===
              get(currentUserStorage.get().privileges, 'id'),
          ),
        )
      ) {
        return `${PAGES.MANAGER_HOME}`;
      } else {
        return `${PAGES.MANAGER_RECAP_PAGE}/${currentClaimId}`;
      }
    } else if (isTransactionManager) {
      return `${PAGES.TRANSACTION_LEGAL_PROCEDDING}/${currentClaimId}`;
    } else {
      return `${PATH_MANAGER}${currentClaimId}`;
    }
  } else if (utils.isExpert(props)) {
    return `${PAGES.EXPERT_ASSIGNED_MISSION_SHOW}/${get(
      currentExpertNotification,
      'mission.id',
    )}?tab=0`;
  } else if (isClaimRejected === STATUS_REJECTED) {
    return `${PAGES.RECAP}/${currentClaimId}`;
  } else if (isInvoiceNotification) {
    return PAGES.FEE_NOTE;
  } else if (isProvisionalClaimNotification) {
    return `${PAGES.PROVISIONAL_CLAIMS_RECAP}/${provisionalClaimId}`;
  } else {
    return `${PATH_LAWYER}${currentClaimId}`;
  }
};

export const renderLegalProceedingTab = (notification: any) => {
  if (
    (get(notification, 'judgement.step', '') === 'JUDGEMENT_ADD' &&
      Number(get(notification, 'judiciaryProcess.procedureNatureId', '')) ===
        3) ||
    (get(notification, 'judgement.step', '') === 'JUDGEMENT_ADD' &&
      get(notification, 'judgement.procedureType', '') === 'APPEAL' &&
      Number(get(notification, 'judiciaryProcess.procedureNatureId', '')) != 3)
  ) {
    return 0;
  } else if (
    ((get(notification, 'judgement.step', '') === 'JUDGEMENT_ADD' &&
      get(notification, 'judgement.procedureType', '') === 'FIRST_INSTANCE') ||
      !isNil(get(notification, 'victimIncomeCertificateId', null))) &&
    Number(get(notification, 'judiciaryProcess.procedureNatureId', '')) != 3
  ) {
    return 1;
  } else if (
    get(notification, 'judgement.step', '') === 'EXPERT_REPORT' &&
    Number(get(notification, 'judiciaryProcess.procedureNatureId', '')) != 3 &&
    get(notification, 'judgement.procedureType', '') === 'FIRST_INSTANCE'
  ) {
    return 2;
  } else if (
    (get(notification, 'judgement.step', '') === 'EXPERT_REPORT' &&
      Number(get(notification, 'judiciaryProcess.procedureNatureId', '')) ===
        3) ||
    (get(notification, 'judgement.step', '') === 'EXPERT_REPORT' &&
      get(notification, 'judgement.procedureType', '') === 'APPEAL' &&
      Number(get(notification, 'judiciaryProcess.procedureNatureId', '')) != 3)
  ) {
    return 1;
  } else if (
    (get(notification, 'judgement.step', '') === 'JUDGEMENT_ON_MERITS' &&
      Number(get(notification, 'judiciaryProcess.procedureNatureId', '')) ===
        3 &&
      (get(notification, 'judgement.procedureType', '') === 'FIRST_INSTANCE' ||
        get(notification, 'judgement.procedureType', '') === 'APPEAL')) ||
    (get(notification, 'judgement.step', '') === 'JUDGEMENT_ON_MERITS' &&
      get(notification, 'judgement.procedureType', '') === 'APPEAL' &&
      Number(get(notification, 'judiciaryProcess.procedureNatureId', '')) != 3)
  ) {
    return 2;
  } else if (
    get(notification, 'judgement.step', '') === 'JUDGEMENT_ON_MERITS' &&
    Number(get(notification, 'judiciaryProcess.procedureNatureId', '')) != 3
  ) {
    return 3;
  } else {
    return 0;
  }
};
export const renderGlobalTab = (notification: any) => {
  if (
    !isEmpty(get(notification, 'judgement', {})) ||
    !isNil(get(notification, 'victimIncomeCertificateId', null)) ||
    (!isNil(get(notification, 'judiciaryProcess.procedureNatureId', null)) &&
      get(notification, 'judiciaryProcess.procedureNatureId', null) != 3)
  ) {
    return 1;
  } else if (
    !isNil(get(notification, 'missionId', null)) &&
    (!isNil(get(notification, 'missionExpertiseVictimId', null)) ||
      !isNil(get(notification, 'missionExpertiseVehicleId', null)) ||
      !isNil(get(notification, 'missionPostPoneId', null)))
  ) {
    return 3;
  } else if (!isNil(get(notification, 'transactionId', null))) {
    return 4;
  } else if (
    !isNil(get(notification, 'regulation.sagisRegulationId', null)) &&
    get(notification, 'regulation.settlementPhase', null) ===
      SETTLEMENT_PHASE.JUDICIARY
  ) {
    return 2;
  } else {
    return 0;
  }
};

export const renderRegulationTab = (notification: any) => {
  if (!isNil(get(notification, 'regulation.sagisRegulationId', null))) {
    return {
      tabIndex: 1,
      paymentId: get(notification, 'regulation.sagisRegulationId', null),
    };
  } else {
    return 0;
  }
};

export const renderTransactionTab = (notification: any) => {
  if (
    !isEmpty(get(notification, 'timelineTransaction', {})) &&
    !isNil(get(notification, 'timelineTransaction.step', null)) &&
    get(notification, 'timelineTransaction.step', null) ===
      TRANSACTION_STEPS.CONTACT_VICTIM
  ) {
    return 1;
  } else if (
    !isEmpty(get(notification, 'timelineTransaction', {})) &&
    !isNil(get(notification, 'timelineTransaction.step', null)) &&
    get(notification, 'timelineTransaction.step', null) ===
      TRANSACTION_STEPS.EXPERTISE
  ) {
    return 2;
  } else if (
    !isEmpty(get(notification, 'timelineTransaction', {})) &&
    !isNil(get(notification, 'timelineTransaction.step', null)) &&
    [
      TRANSACTION_STEPS.FIRST_VALIDATION_REGULATION,
      TRANSACTION_STEPS.SECOND_VALIDATION_REGULATION,
      TRANSACTION_STEPS.SECOND_VALIDATION_REGULATION,
    ].includes(get(notification, 'timelineTransaction.step', null))
  ) {
    return 3;
  } else {
    return 0;
  }
};

export const renderInstanceTab = (judgement: any) => {
  if (get(judgement, 'procedureType', '') === 'FIRST_INSTANCE') {
    return 0;
  } else if (get(judgement, 'procedureType', '') === 'APPEAL') {
    return 1;
  } else {
    return 0;
  }
};

export const renderExpertiseTab = (notification: any) => {
  if (
    !isNil(get(notification, 'missionExpertiseVehicleId', null)) ||
    !isNil(get(notification, 'missionExpertiseVictimId', null))
  ) {
    return 0;
  } else if (!isNil(get(notification, 'missionPostPoneId', null))) {
    if (
      get(notification, 'missionPostPone.type', null) ===
      MISSION_POSTPONE_TYPE.NOTICE_DEFICIENCY
    ) {
      return 1;
    } else {
      return 2;
    }
  } else {
    return 0;
  }
};
export const formatManagerInboxesNotification = (
  managerNotification: any,
  openingManagerNotifications: any,
) => {
  const openingManagerNotif = !isEmpty(openingManagerNotifications)
    ? openingManagerNotifications.map((et: any) => ({
        ...et,
        created_at: et?.createdAt,
        updated_at: et?.updatedAt,
        type: NOTIFICATION_CLAIM_CONVERTION,
      }))
    : openingManagerNotifications;
  return [
    ...managerNotification,
    ...openingManagerNotif.filter(
      (item: any) => !isNull(item.managerNotificationTypeId),
    ),
  ];
};

export const isRejectionTitle = (title: any) => {
  return title.includes(EXPERT_REJECTION_TITLE_NOTIFICATION);
};

export const isInboxeTitle = (title: any) => {
  return title.includes(ASSIGNEMENT_INBOXE_TITLE_NOTIFICATION);
};

export const isAlertNotificationForLawyer = (title: any) => {
  return title.includes(DELAY_MISSION_TITLE_MOTIFICATION);
};

export const renderTitleConfirmationDialog = (
  lawyerNotifications: any,
  messages: any,
  props: any,
  currentNotification: any,
) => {
  if (!isEmpty(lawyerNotifications)) {
    return translate(messages.sideBarNotificationDialogContentLawyer, props);
  } else {
    if (isManager(props)) {
      if (isRejectionTitle(get(currentNotification, 'title'))) {
        return translate(messages.assignExpertTitle, props);
      } else if (isInboxeTitle(get(currentNotification, 'title'))) {
        return translate(messages.assignementInboxeTitle, props);
      } else {
        return translate(messages.sideBarNotificationDialogContent, props);
      }
    } else {
      return translate(messages.sideBarNotificationDialogContent, props);
    }
  }
};
export const renderSubTitleConfirmationDialog = (
  lawyerNotifications: any,
  messages: any,
  props: any,
  currentNotification: any,
) => {
  if (!isEmpty(lawyerNotifications)) {
    return '';
  } else {
    if (isManager(props)) {
      if (isRejectionTitle(get(currentNotification, 'title'))) {
        return '';
      } else if (isInboxeTitle(get(currentNotification, 'title'))) {
        return '';
      } else {
        return translate(messages.sideBarNotificationDialogInfo, props);
      }
    } else {
      return translate(messages.sideBarNotificationDialogInfo, props);
    }
  }
};

export const getTimeDifference = (targetDate: string) => {
  const difference = new Date().getTime() - new Date(targetDate).getTime();

  if (difference > 0) {
    const timeLeft = {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
    };
    return timeLeft;
  }

  return undefined;
};

export const getTransactionArea = (
  transactionInboxeAreaId: any,
  listings: any,
) => {
  if (!isNil(transactionInboxeAreaId)) {
    return (
      ' - ' +
      get(
        get(listings, 'transactionArea', []).find(
          (it: any) =>
            String(it.id) ===
            String(
              get(
                get(listings, 'transactionInboxeArea', []).find(
                  (item: any) =>
                    String(item.id) === String(transactionInboxeAreaId),
                ),
                'transactionAreaId',
              ),
            ),
        ),
        'title',
      )
    );
  } else {
    return '';
  }
};

export const setActiveStepper = (
  props: any,
  history: any,
  setActiveStep: Function,
) => {
  if (props.isBasicManagement) {
    if (props.isCourtManager) {
      switch (history.location.pathname) {
        case PAGES.PREOPENING_MANAGER:
          return setActiveStep(
            PAGES_INDEX_COURT_MANAGER.indexOf(PAGES.PREOPENING_MANAGER),
          );
        case PAGES.PREOPENING_MANAGER_UPLOAD_DOCUMENTS:
          return setActiveStep(
            PAGES_INDEX_COURT_MANAGER.indexOf(
              PAGES.PREOPENING_MANAGER_UPLOAD_DOCUMENTS,
            ),
          );
        case PAGES.PREOPENING_MANAGER_RECAPITULATIF:
          return setActiveStep(
            PAGES_INDEX_COURT_MANAGER.indexOf(
              PAGES.PREOPENING_MANAGER_RECAPITULATIF,
            ),
          );
      }
    } else {
      switch (history.location.pathname) {
        case PAGES.IDENTIFICATION_PREOPEN_MANAGER:
          return setActiveStep(
            PAGES_INDEX_PREOPEN_MANAGER.indexOf(
              PAGES.IDENTIFICATION_PREOPEN_MANAGER,
            ),
          );
        case PAGES.PREOPEN_CLAIM_PREOPEN_MANAGER:
          return setActiveStep(
            PAGES_INDEX_PREOPEN_MANAGER.indexOf(
              PAGES.PREOPEN_CLAIM_PREOPEN_MANAGER,
            ),
          );
        case PAGES.UPLOAD_DOCUMENTS_PREOPEN_MANAGER:
          return setActiveStep(
            PAGES_INDEX_PREOPEN_MANAGER.indexOf(
              PAGES.UPLOAD_DOCUMENTS_PREOPEN_MANAGER,
            ),
          );
        case PAGES.RECAPITULATIF_PREOPEN_MANAGER:
          return setActiveStep(
            PAGES_INDEX_PREOPEN_MANAGER.indexOf(
              PAGES.RECAPITULATIF_PREOPEN_MANAGER,
            ),
          );
        case PAGES.PREOPENING_MANAGER_JUDICIARY_PROCESS:
          return setActiveStep(
            PAGES_INDEX_PREOPEN_MANAGER.indexOf(
              PAGES.PREOPENING_MANAGER_JUDICIARY_PROCESS,
            ),
          );
      }
    }
  }
  if (props.isOpeningManager) {
    switch (history.location.pathname) {
      case PAGES.OPENING_CLAIM:
        return setActiveStep(PAGES_INDEX_MANAGER.indexOf(PAGES.OPENING_CLAIM));
      case PAGES.UPLOAD_DOCUMENTS_MANAGER:
        return setActiveStep(
          PAGES_INDEX_MANAGER.indexOf(PAGES.UPLOAD_DOCUMENTS_MANAGER),
        );
      case PAGES.RECAPITULATIF_MANAGER:
        return setActiveStep(
          PAGES_INDEX_MANAGER.indexOf(PAGES.RECAPITULATIF_MANAGER),
        );
    }
  } else if (props.isPreOpeningManager) {
    switch (history.location.pathname) {
      case PAGES.IDENTIFICATION_PREOPEN_MANAGER:
        return setActiveStep(
          PAGES_INDEX_PREOPEN_MANAGER.indexOf(
            PAGES.IDENTIFICATION_PREOPEN_MANAGER,
          ),
        );
      case PAGES.PREOPEN_CLAIM_PREOPEN_MANAGER:
        return setActiveStep(
          PAGES_INDEX_PREOPEN_MANAGER.indexOf(
            PAGES.PREOPEN_CLAIM_PREOPEN_MANAGER,
          ),
        );
      case PAGES.UPLOAD_DOCUMENTS_PREOPEN_MANAGER:
        return setActiveStep(
          PAGES_INDEX_PREOPEN_MANAGER.indexOf(
            PAGES.UPLOAD_DOCUMENTS_PREOPEN_MANAGER,
          ),
        );
      case PAGES.RECAPITULATIF_PREOPEN_MANAGER:
        return setActiveStep(
          PAGES_INDEX_PREOPEN_MANAGER.indexOf(
            PAGES.RECAPITULATIF_PREOPEN_MANAGER,
          ),
        );
    }
  } else {
    switch (history.location.pathname) {
      case PAGES.IDENTIFICATION:
        return setActiveStep(PAGES_INDEX.indexOf(PAGES.IDENTIFICATION));
      case PAGES.PREOPENING:
        return setActiveStep(PAGES_INDEX.indexOf(PAGES.PREOPENING));
      case PAGES.UPLOAD_DOCUMENTS:
        return setActiveStep(PAGES_INDEX.indexOf(PAGES.UPLOAD_DOCUMENTS));
      case PAGES.RECAPITULATIF:
        return setActiveStep(PAGES_INDEX.indexOf(PAGES.RECAPITULATIF));
    }
  }
};

export const getSteps = (props: any) => {
  if (props.isBasicManagement) {
    if (props.isCourtManager) {
      return [
        translate({ ...messages.stepperPreopening }, props),
        translate({ ...messages.stepperUploadDocs }, props),
        translate({ ...messages.stepperSummary }, props),
      ];
    } else {
      return [
        translate({ ...messages.stepperIdentification }, props),
        translate({ ...messages.stepperPreopening }, props),
        translate({ ...messages.stepperUploadDocs }, props),
        translate({ ...messages.stepperSummary }, props),
        translate({ ...messages.judiciaryProcess }, props),
      ];
    }
  }
  return props.isOpeningManager
    ? [
        translate({ ...messages.stepperCompleteOpening }, props),
        translate({ ...messages.stepperUploadDocs }, props),
        translate({ ...messages.stepperSummary }, props),
      ]
    : [
        translate({ ...messages.stepperIdentification }, props),
        translate({ ...messages.stepperPreopening }, props),
        translate({ ...messages.stepperUploadDocs }, props),
        translate({ ...messages.stepperSummary }, props),
      ];
};

export const isLawyer = () => {
  const currentUser = currentIntervenantStorage.get();
  return currentUser && currentUser?.roles.includes(LAWYER_ROLE);
};

export const renderLawyerLegalProceedingTab = (notification: any) => {
  if (
    get(notification, 'lawyerInboxes.title', null) ===
      LAWYER_INBOXES_TITLES.FIRM_REFERENCE &&
    get(notification, 'judiciaryProcess.procedureNatureId', null) === 3
  ) {
    return 0;
  } else if (
    get(notification, 'lawyerInboxes.title', null) ===
      LAWYER_INBOXES_TITLES.FIRM_REFERENCE &&
    get(notification, 'judiciaryProcess.procedureNatureId', null) != 3
  ) {
    return 1;
  } else if (
    get(notification, 'lawyerInboxes.title', null) ===
      LAWYER_INBOXES_TITLES.CONTESTATION_APPEAL &&
    (get(notification, 'judiciaryProcess.procedureNatureId', null) === 3 ||
      (Number(get(notification, 'judiciaryProcess.procedureNatureId', '')) !=
        3 &&
        get(notification, 'judgement.procedureType', '') ===
          PROCEDURE_TYPES.APPEAL))
  ) {
    return 2;
  } else if (
    get(notification, 'lawyerInboxes.title', null) ===
      LAWYER_INBOXES_TITLES.CONTESTATION_APPEAL &&
    get(notification, 'judgement.procedureType', '') ===
      PROCEDURE_TYPES.FIRST_INSTANCE &&
    Number(get(notification, 'judiciaryProcess.procedureNatureId', '')) != 3
  ) {
    return 3;
  } else {
    return 0;
  }
};

export const renderLawyerGlobalTab = (notification: any) => {
  if (
    !isNil(get(notification, 'lawyerInboxes.title', null)) &&
    (get(notification, 'lawyerInboxes.title', null) ===
      LAWYER_INBOXES_TITLES.FIRM_REFERENCE ||
      get(notification, 'lawyerInboxes.title', null) ===
        LAWYER_INBOXES_TITLES.CONTESTATION_APPEAL)
  ) {
    return 1;
  } else {
    return 0;
  }
};

export const getInformations = (props: any, keycloak: any, userInfo: any) => {
  if (!isManager(props) && keycloak && userInfo) {
    currentUserStorage.clear();
    accessTokenStorage.clear();
    OverLayStorage.clear();
    currentIntervenantStorage.set(userInfo as CurrentLawyer);
    return {
      userInfo,
      logout: keycloak.logout,
    };
  } else if (
    isManager(props) &&
    currentUserStorage.get() &&
    currentUserStorage.get().username
  ) {
    currentIntervenantStorage.clear();
    return {
      userInfo: {
        name: currentUserStorage.get().username,
      },
      logout: props.requestLogout,
    };
  } else {
    return {
      userInfo: {},
      logout: () => null,
    };
  }
};
